export const PROVEN_SUCCESS_FAQ_URL = {
  fr: 'https://support.ankorstore.com/contents/Proven-Success-vZMHGsxT',
  en: 'https://support.ankorstore.com/en-gb/contents/Proven-Success-badge-vZMHGsxT',
  de: 'https://support.ankorstore.com/de-de/contents/Bewahrter-Erfolg-vZMHGsxT',
  es: 'https://support.ankorstore.com/es-es/contents/Exito-comprobado-vZMHGsxT',
  it: 'https://support.ankorstore.com/it-it/contents/Successo-comprovato-vZMHGsxT',
};

const FAST_DELIVERY_FAQ_URL = {
  fr: 'https://support.ankorstore.com/contents/La-livraison-en-48h-partout-en-France-QLubndgC',
  en: 'https://support.ankorstore.com/en-gb/contents/48-hour-delivery-anywhere-in-France-QLubndgC',
  de: 'https://support.ankorstore.com/en-gb/contents/48-hour-delivery-anywhere-in-France-QLubndgC',
  es: 'https://support.ankorstore.com/en-gb/contents/48-hour-delivery-anywhere-in-France-QLubndgC',
  it: 'https://support.ankorstore.com/en-gb/contents/48-hour-delivery-anywhere-in-France-QLubndgC',
};

export const URL_LINKS = {
  proven_success: PROVEN_SUCCESS_FAQ_URL,
  fast_shipping: FAST_DELIVERY_FAQ_URL,
  repeat_offers: { name: 'ankorstore-plus-signup' },
};
